import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {MemberRewardCourtPage} from './member-reward-court';
import {SharedModule} from '../../../../shared/shared.module';

@NgModule({
    declarations: [MemberRewardCourtPage],
    imports: [
        SharedModule,
        RouterModule.forChild([
            {
                path: '',
                component: MemberRewardCourtPage
            }
        ])
    ]
})
export class MemberRewardCourtModule {
}
